import { useSelector } from 'react-redux';

import config from 'lib/config';
import authorizedFetch from 'lib/authorizedFetch';
import { SrpFilterApiParams, transformSrpFilterStateToApiParams } from 'lib/srpFilterTransformers';

import { getSrpFilterValues } from 'redux-implementations/selectors';

import State from 'types/State';
import { SearchItem } from 'types/Apis/SearchResponse';
import { InitialSrpParams } from './useSrpModel';

function filterNullParams(params: InitialSrpParams | SrpFilterApiParams): SrpFilterApiParams {
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => !(v === null || v === undefined))
  );
}
export default function useSaveSearch(): { saveSearch: () => Promise<SearchItem> } {
  const locationState = useSelector((state: State) => state?.geolocation);
  const filterValues = useSelector(getSrpFilterValues);

  const apiParams = transformSrpFilterStateToApiParams(filterValues);

  function saveSearch(): Promise<SearchItem> {
    return authorizedFetch(`${config.coreApiUrl}/api/saved_searches`, {
      method: 'POST',
      body: JSON.stringify({
        source: 'create_ss_srp',
        city: locationState?.city ?? '',
        state: locationState?.stateAbbreviation ?? '',
        zip: locationState?.zip ?? '',
        search_parameters: filterNullParams(apiParams),
      }),
    });
  }

  return { saveSearch };
}
